import React from 'react';
import { FaGlobe } from 'react-icons/fa';
import { imageAssetUrl } from '../contentUrls';

export default function Presentedby() {
  return (
    <section id="presentedby" className="p-8 text-center font-tattoo">
      <div className="max-w-screen-xl mx-auto">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold uppercase mb-6 text-primary">Proudly Presented By</h2>
        <div className="flex flex-col lg:flex-row items-center lg:items-start lg:justify-between gap-6">
          {/* Left Column - Image with Link */}
          <div className="w-full lg:w-3/4 border-4 border-primary hover:border-deepRed transition duration-300 ease-in-out rounded-lg">
            <a href="https://www.stjohnstattooconvention.com" target="_blank" rel="noopener noreferrer">
              <img 
                src={imageAssetUrl('image--TBS.jpg')}
                alt="St. John's Tattoo Convention" 
                className="rounded-lg shadow-lg w-full h-auto hover:scale-105 hover:opacity-90 transition duration-300 ease-in-out"
              />
            </a>
          </div>
          {/* Right Column - Content */}
          <div className="w-full lg:w-1/4 text-base md:text-lg lg:text-xl text-left mt-4 lg:mt-0 lg:pl-6">
            <p>
            For over 20 years, Trouble Bound Studio has been a cornerstone of custom tattooing in St. John’s, Newfoundland. Located on the historic Water Street, we pride ourselves on the highest standards. 
            </p>
            <p className="mt-4 flex items-center">
              <FaGlobe className="text-primary mr-2" />
              <a href="https://troubleboundtattoos.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:text-white transition duration-200">
               Website
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
